import { useEffect, useState } from 'react'
import { Row, Col, Container, Dropdown, Form, Modal,Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Card from '../../components/Card'
import CustomToggle from '../../components/dropdowns'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { RiCloseCircleFill } from "react-icons/ri";

//image
import img1 from '../../assets/images/small/07.png'
import img2 from '../../assets/images/small/08.png'
import img3 from '../../assets/images/small/09.png'
import s5 from '../../assets/images/page-img/s5.jpg'
import img42 from '../../assets/images/page-img/42.png'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast';
import { getToken } from '../../utils/auth'
import { useNavigate } from 'react-router-dom'
import { MdOutlineDone } from "react-icons/md"
import moment from 'moment'
import PostCard from './Post/PostCard'
import useAuth from '../../utils/useAuth'
import Sponsored from './Sponsored'
import { useTranslation } from 'react-i18next'
import { useUser } from '../../Context/UserContext'

const AllPost = () => {
      const { userData } = useUser();
    
    useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!getToken()) {
            navigate("/auth/sign-in")
        }
    }, []);
    const [show, setShow] = useState(false);
    const handleClose = () => {
      setShow(false)
      setDescription("")
      setSelectedFile([])
      setImagePreview(null)
    };
    const handleShow = () => setShow(true);
    const [description, setDescription] = useState("");
    const [expandedRows, setExpandedRows] = useState({});
    const [selectedFile, setSelectedFile] = useState([]);
    const [imagePreview, setImagePreview] = useState([]);
    const { t, i18n } = useTranslation();
    const [post, setPost] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
  //   const handleFileInputChange = (event) => {
  //     const files = Array.from(event.target.files);
  //     setSelectedFile(files);
  //     const previews = files.map(file => URL.createObjectURL(file));
  //     setImagePreview(previews);
  //     toast.success("File selected!");
  // };


const handleFileInputChange = (event) => {
  const files = Array.from(event.target.files);
  setSelectedFile(files);
  const filePreviews = files.map((file) => ({
    url: URL.createObjectURL(file),
    type: file.type.startsWith("image") ? "image" : "video",
  }));
  setImagePreview(filePreviews);
};
    
const handleRemove = (index) => {
  const updatedPreviews = imagePreview.filter((_, i) => i !== index);
  const updatedFiles = selectedFile.filter((_, i) => i !== index);

  setImagePreview(updatedPreviews);
  setSelectedFile(updatedFiles);
};
const toggleExpand = (index) => {
        setExpandedRows((prevExpandedRows) => ({
            ...prevExpandedRows,
            [index]: !prevExpandedRows[index],
        }));
    };

    
    const [categorypost, setCategorypost] = useState("public");

    const handleCategoryChange = (e) => {
        setCategorypost(e.target.value);
    };
    const [photos, setPhotos] = useState([]);
    // const handlePost = async () => {

    //     const maxFileSize = 2 * 1024 * 1024;
    //     for (let i = 0; i < selectedFile.length; i++) {
    //         if (selectedFile[i].size > maxFileSize) {
    //             toast.error("File size must not exceed 2MB");
    //             return;
    //         }
    //     }

    //     if (!description) {
    //         toast.error("Description is required");
    //         return;
    //     }
    //     try {
      // const token = getToken();

    //         const formData = new FormData();
    //         for (let i = 0; i < selectedFile.length; i++) {
    //             formData.append('files', selectedFile[i]);
    //         }

    //         const uploadResponse = await axios.post(
    //             `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
    //             formData,
    //             {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     'Authorization': `Bearer ${token}`,
    //                 },
    //             }
    //         );
    //         console.log("oath", uploadResponse.data.data)

    //         setPhotos(uploadResponse.data.data)
    //         postPhoto(uploadResponse.data.data);


    //         //   setShow(false);
    //     } catch (error) {
    //         console.log("Failed to create post:", error);
    //         toast.error(error?.uploadResponse?.data?.message || "Failed to Upload Image/Video");
    //     }
    // };
    const handlePost = async () => {
        const maxFileSize = 1 * 1024 * 1024;
        
        for (let i = 0; i < selectedFile.length; i++) {
            if (selectedFile[i].size > maxFileSize) {
                toast.error("File size must not exceed 1MB");
                return;
            }
        }
    
        if (!description) {
            toast.error("Description is required");
            return;
        }
    
        try {
          const token = getToken();

            let uploadedPhotos = [];
    
            if (selectedFile.length > 0) {  // Only upload if files are selected
                const formData = new FormData();
                for (let i = 0; i < selectedFile.length; i++) {
                    formData.append('files', selectedFile[i]);
                }
    
                const uploadResponse = await axios.post(
                    `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${token}`,
                        },
                    }
                );
                uploadedPhotos = uploadResponse.data.data;
            }
            
            setPhotos(uploadedPhotos)
            postPhoto(uploadedPhotos);
        } catch (error) {
            console.log("Failed to upload image:", error);
            toast.error(error?.response?.data?.message || "Failed to Upload Image/Video");
        }
    };
    

    const postPhoto = async (photoss) => {
        if (!description) {
            toast.error("Description is required");
            return;
        }
        try {
          const token = getToken();

            const postData = {
                description: description,
                photos: photoss,
                postType: categorypost,
            };

            const postResponse = await axios.post(
                `${process.env.REACT_APP_URL}/api/post`,
                postData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                }
            );
            setPost([]);
            setPage(1);
            handleAllPost();
            toast.success("Post created successfully");
            setDescription("");
            setSelectedFile([]);
            //   setShow(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log("Failed Posting ", error);
        } finally {
            setShow(false);
        }
    }

    const [user, setUser] = useState("");

    const fetchUserData = async () => {
      try {
        const token = getToken();
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log("user details header", response.data.data);
        setUser(response?.data?.data);
      } catch (error) {
        console.error("Failed Fetching Details", error);
      }
    };
    useEffect(() => {
        fetchUserData();
    },[])


    const handleAllPost = async (updateData = false) => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/post/all?page=${page}&limit=5&searchFor=all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data"
                }
            }
            )
            // console.log("Post Fetched Successfully", response.data.data.allPosts);
            // setPost(response.data.data.allPosts);
            // setHasMore(response.data.data.allPosts.length > 0);
            if (updateData) {
                setPost(response.data.data.allPosts);
            } else {
                setPost((prevPost) => [...prevPost, ...response.data.data.allPosts]);
            }
            setHasMore(response.data.data.allPosts.length > 0);

        } catch (error) {
            console.log("Failed Fetching Posts", error);
        }
    }

    useEffect(() => {
        handleAllPost();
    }, [page])

    const [upcoming, setUpcoming] = useState([]);
    const handleUpcoming = async () => {
        try {
            const token = getToken();
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/event/upcoming/all`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    // "Content-Type": "multipart/form-data"
                }
            }
            )
            // console.log("Upcoming Event Fetched Successfully", response.data.data.allEvents);
            setUpcoming(response.data.data.allEvents);
        } catch (error) {
            console.log("Failed Fetching Upcoming Event", error);
        }
    }

    useEffect(() => {
        handleUpcoming();
    }, [])

    const [qrPopupOpen, setQrPopupOpen] = useState(false);
    const [qrImageUrl, setQrImageUrl] = useState('');

    const handleQrClick = (imageUrl) => {
        setQrImageUrl(imageUrl);
        setQrPopupOpen(true);
    };

    const closeQrPopup = () => {
        setQrPopupOpen(false);
    };


 
    const [reportModalOpen, setReportModalOpen] = useState(false);
    const [reportDescription,setReportDescription] = useState("");
    const [reportId, setReportId] = useState("");
    const handleReportClick = (reqid) => {
      setReportId(reqid);
      setReportModalOpen(true);
    };
  
    const closeReportModal = () => {
      setReportModalOpen(false);
    };
    const handleReport = async () => {
      if (!reportDescription) {
          toast.error("Report issue is required");
          return;
        }
      try {
        const token = getToken();
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/api/report`,
          {
            reportFor: "post",
            issueDescription: reportDescription,
            userId: "",
            postId: reportId,
            eventId: "",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        closeReportModal();
        setReportId("");
        setReportDescription("");
        toast.success(response.data.message);
  
      } catch (error) {
          setReportId("");
        setReportDescription("");
        toast.error(error?.response?.data?.message || "Failed Reporting Post");
        console.log("Failed SaviReportingng Posts", error);
      }
    };
 const openEvent = (id) => {
// navigate(`https://demo.dirido.com/event/${id}`)
window.open(`https://demo.dirido.com/event/${id}`, '_blank');
}

    const [showGroupPopup, setShowGroupPopup] = useState(false);
    const [ postidDetail, setPostidDetail] = useState("");
    const handleCloseGroupPopup = () => setShowGroupPopup(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [groups, setGroups] = useState([]);

    const handleAllGroups = async () => {
      try {
        const token = getToken();
        let url = `${process.env.REACT_APP_URL}/api/group/all?searchfor=my`;
  
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        setGroups(response.data.data);
        
      } catch (error) {
        console.log("Failed Fetching Group", error);
      }
    };
  
    useEffect(() => {
      handleAllGroups();
    }, []);
    
    const handleGroupSelection = (e) => {
        const value = e.target.value;
        setSelectedGroups(prev =>
          prev.includes(value) ? prev.filter(group => group !== value) : [...prev, value]
        );
      };

    const handleShowGroupPopup = (postid) => {
        setPostidDetail(postid);
        setShowGroupPopup(true);}

        const handleSubmit = async () => {
            if (!postidDetail) {
                toast.error("Please try later");
                return;
              }
            const payload = {
                postId: postidDetail,
              groupIds: selectedGroups,
            };
            const token = getToken();
        
            try {
              const response = await axios.post(`${process.env.REACT_APP_URL}/api/post/share-group`, payload, {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                },
              });
              toast.success(response.data.message);
              setSelectedGroups([]);
              handleCloseGroupPopup();
            } catch (error) {
                toast.error("Error sharing post")
              console.log('Share request failed', error);
            }
            
          };

    return (
        <>
<Toaster position="top-right" reverseOrder={false}/>
<div id="content-page" className="content-page">

                <Container>
                    <Row>
                        <Col lg={8} className="row m-0 p-0">
                            <Col sm={12} >
                                <Card id="post-modal-data" className="card-block card-stretch card-height">
                                    <div className="card-header d-flex justify-content-between">
                                        <div className="header-title">
                                            <h4 className="card-title">{t('createPost')}</h4>
                                        </div>
                                    </div>
                                    <Card.Body >
                                        <div className="d-flex align-items-center">
                                            <div className="user-img">
                                                <img 
                                                src={userData?.profileImageLink ? userData?.profileImageLink : '/profile.png'}
                                                // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`} 
                                                alt="user1" className="avatar-60 rounded-circle" />
                                            </div>
                                            <form className="post-text ms-3 w-100 " onClick={handleShow}>
                                                <input type="text" className="form-control rounded" placeholder={t('writeSomethingHere')} style={{ border: "none" }} />
                                            </form>
                                        </div>
                                      
                                    </Card.Body>
                                    <Modal centered size="lg" className="fade" id="post-modal" onHide={handleClose} show={show} style={{ marginTop: "100px", maxHeight: "80vh" }}>
                                        <Modal.Header className="d-flex justify-content-between">
                                            <Modal.Title id="post-modalLabel">{t('createPost')}</Modal.Title>
                                            <Link to="#" className="lh-1" onClick={handleClose} >
                                                <span className="material-symbols-outlined">close</span>
                                            </Link>
                                        </Modal.Header>
                                        <Modal.Body >
                                        <div className="d-flex align-items-center">
                                            <div className="user-img">
                                                <img src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`} alt="user1" className="avatar-60 rounded-circle" />
                                            </div>
                                            <form className="post-text ms-3 w-100 " onClick={handleShow}>
                                                <input type="text" className="form-control rounded" placeholder="Write something here..." style={{ border: "none" }} value={description}                         
                            onChange={(e) => setDescription(e.target.value)}/>
                                            </form>
                                        </div>
                                        <hr></hr>
                                            <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                                               
                                               
                                                <li className="col-12 mb-2" >
                                                  
                                                    <Form.Label>
                                                    {t('image')}{" "}
                                                        {/* <span style={{ color: "red" }}>*</span>{" "} */}
                                                    </Form.Label>
                                                    <label
                                                        htmlFor="file-input"
                                                        style={{ cursor: "pointer", width: "100%" }}
                                                    >
                                                        <div
                                                            className="bg-soft-primary rounded p-1 pointer"
                                                            style={{
                                                                width: "100%",
                                                                textAlign: "center",
                                                                fontSize: "1.2rem",
                                                                position: "relative",
                                                                borderRadius: "10px",
                                                            }}
                                                        >
                                                            <input
                                                                id="file-input"
                                                                type="file"
                                                                accept="image/*,video/mp4"
                                                                name="image"
                                                                multiple
                                                                style={{ display: "none" }}
                                                                onChange={handleFileInputChange}
                                                            />
                                                            <span>
                                                                {
                                                                    selectedFile.length > 0 ?
                                                                        <MdOutlineDone style={{ fontSize: '25px' }} />
                                                                        :
                                                                        <i className="fas fa-upload"></i>
                                                                }
                                                            </span>
                                                            <p style={{ marginTop: ".5rem" }}>
                                                                {t('click_to_select_files')}
                                                            </p>
                                                        </div>
                                                    </label>

  {imagePreview?.length > 0 && (
        <div
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "auto",
            gap: "10px",
            marginTop: "20px",
            paddingTop:"10px",
          }}
        >
          {imagePreview?.map((preview, index) => (
            <div key={index} style={{ position: "relative" }}>
              {/* Remove Icon */}
              <RiCloseCircleFill
                size={24}
                color="red"
                style={{
                  position: "absolute",
                  top: "-8px",
                  right: "-8px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
                onClick={() => handleRemove(index)}
              />

              {preview?.type === "image" ? (
                <img
                  src={preview?.url}
                  alt={`Preview ${index + 1}`}
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
              ) : (
                <video
                  src={preview?.url}
                  controls
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: "10px",
                  }}
                />
              )}
            </div>
          ))}
        </div>
      )}
                                                </li>
                                                <li className="col-12 mt-1">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('selectCategory')}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Form.Label>
                            <div className="mb-0 ">
                              <Form.Check
                                style={{ marginRight: "20px", whiteSpace:"nowrap" }}
                                type="radio"
                                name="category"
                                value="public"
                                label={t('public')}
                                checked={categorypost === "public"}
                                onChange={handleCategoryChange}
                                required
                              />
                              <Form.Check style={{whiteSpace:"nowrap"}}
                                type="radio"
                                name="category"
                                value="private"
                                label={t('connections')}
                                checked={categorypost === "private"}
                                onChange={handleCategoryChange}
                                required
                              />
                            </div>
                          </Form.Group>
                        </li>

                                            </ul>

                                                        <button type="submit" className="btn btn-primary d-block w-100 mt-0" onClick={handlePost}>{t('post')}</button>
                                        </Modal.Body>
                                    </Modal>
                                    <Modal size="md" className="fade" onHide={handleCloseGroupPopup} show={showGroupPopup} centered style={{maxHeight:"70vh", marginTop:"100px"}}>
        <Modal.Header closeButton style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
          <Modal.Title>{t('select_groups')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {groups.length === 0 ? (
      <div>{t('no_groups_found')}</div>
    ) : (
          <Form.Group>
            <Form.Label>{t('select_groups_to_share')}</Form.Label>
            <div className="d-flex flex-column">
              {groups.map((group, index) => (
                <div
                  key={index}
                  style={{
                    padding: '10px',
                    margin: '5px 0',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    backgroundColor: selectedGroups.includes(group._id) ? '#d1e7dd' : '#f8f9fa',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={() => {
                    setSelectedGroups(prev =>
                      prev.includes(group._id) ? prev.filter(g => g !== group._id) : [...prev, group._id]
                    );
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    // label={group.groupName}
                    value={group._id}
                    checked={selectedGroups.includes(group._id)}
                    onChange={handleGroupSelection}
                    style={{ marginRight: '10px' }}
                  />
                  <span>{group.groupName}</span>
                </div>
              ))}
            </div>
          </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer style={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', zIndex: 10 }}>
          <Button variant="secondary" onClick={handleCloseGroupPopup}>
          {t('close')}
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
          {t('share')}
          </Button>
        </Modal.Footer>
      </Modal>
                                </Card>
                            </Col>
                            <PostCard post={post} page={page} setPage={setPage} hasMore={hasMore} handleAllPost={handleAllPost} handleShowGroupPopup={handleShowGroupPopup}/>
                        </Col>
                        <Col lg={4}>
                            <Sponsored/>
                            <Card className="d-none d-lg-flex">
                                <div className="card-header d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">{t('upcoming_events')}</h4>
                                    </div>
                                    
                                </div>
                                <Card.Body>
                                    <ul className="media-story list-inline m-0 p-0">
                                        {upcoming?.length === 0 ? (
                                            <li className="d-flex mb-4 align-items-center">
                                                <div className="stories-data ms-3">
                                                    <h5 className="mb-1" style={{ fontWeight: 'bold', color: 'gray' }}>{t('no_upcoming_events')}</h5>
                                                </div>
                                            </li>
                                        ) : (
                                            upcoming?.slice(0,4).map?.((data, index) => (
                                                <li key={index} className="d-flex mb-4 align-items-center" >
                                                    <img src={data?.image || s5} alt="story1" className="rounded-circle img-fluid" style={{ width: '50px', height: '50px' }} />
                                                    <div className="stories-data ms-3">
                                                        <h5 className="mb-1 hover-blue-event" style={{ fontWeight: 'bold', textTransform: 'capitalize', cursor:"pointer" }} onClick={() => window.open(`https://demo.dirido.com/event/${data?._id}`, '_blank')}>{data?.title}</h5>
                                                        <p className="mb-0">
                                                            {moment(data?.startDate).format('MMMM Do YYYY, h:mm a')}
                                                        </p>
                                                        <p className="mb-0">
                                                            {t('organized_by')}: {data?.userId?.firstName} {data?.userId?.lastName}
                                                        </p>
                                                    </div>
                                                </li>
                                            ))
                                        )}
                                    </ul>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default AllPost
